import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ThinCheckbox } from 'components/common/Styles';
import TextTableCell from 'components/common/table/TextTableCell';

const AutomaticStateTransitionItem = ({ data }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/automaticStateTransitions/${data.automaticStateTransitionId}`);
  }, [historyContext, data]);

  return (
    <TableRow hover>
      <TableCell>{data.documentCode}</TableCell>
      <TableCell>{data.documentName}</TableCell>
      <TextTableCell content={data.fromStateCode} />
      <TableCell>{data.fromStateName}</TableCell>
      <TableCell align='center'>
        <ThinCheckbox disabled={true} size='small' checked={data.inactive} />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          type='edit'
          size='small'
          variant='text'
          color='primary'
          tooltip={t('AutomaticStateTransitions.Edit')}
          onClick={handleEdit}
        />
      </TableCell>
    </TableRow>
  );
};

AutomaticStateTransitionItem.propTypes = {
  data: PropTypes.object.isRequired
};

export default AutomaticStateTransitionItem;
